/**
 * Builds the basic auth header using environment variables.
 * @returns An object containing the Authorization header or undefined if credentials are missing.
 */
export function buildBasicAuthHeader() {
  const username = process.env.REACT_APP_BASIC_AUTH_USER;
  const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;
  if (!username || !password) return undefined;
  return { Authorization: `Basic ${btoa(`${username}:${password}`)}` };
}

/**
 * Builds the auth header using encrypted access token
 * @returns An object containing the Authorization header or undefined if token not provided missing.
 */
export function buildOAuthHeader(token: string) {
  if (!token || !token?.trim()) return undefined;
  return { Authorization: `Bearer ${token}` };
}
